module.exports = __webpack_public_path__ + "img/error.b00e232f.gif";